import { getListF2OfUser } from "../model/profile"

export const setF2Filter = (filter) => {
	return {
			type: "SET_F2_FILTER",
			payload: filter
	}
}

export function listF2(pos, count, filter) {
    return {
        type: "LIST_F2",
        payload: getListF2OfUser(pos, count, filter)
    }
}





// WEBPACK FOOTER //
// ./src/actions/listF2Act.js